import { z } from "zod";

export const TaxonomyRoleItemSchema = z.object({
  Id: z.string(),
  Name: z.string(),
  Code: z.string().optional(),
  StateCode: z.number().optional(),
});

export type TaxonomyRoleItemType = z.infer<typeof TaxonomyRoleItemSchema>;
